import { brandPalette } from "../../../../constants/brandPalette";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  SimpleGrid,
  Stack,
  Switch,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import ReactQuill from "react-quill";
import MathQuill4Quill from 'mathquill4quill';
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminSelectStyles,
} from "../../../../components/Models/admin-modal-theme";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import { closeCreateQuestionModel } from "../../../../modules/admin-modules/models/Actions";
import {
  createQuestionBankRequest,
  editQuestionBankRequest,
} from "../../../../modules/admin-modules/questions-bank/Actions";
import { getAllTagsRequest } from "../../../../modules/admin-modules/tags/Actions";

import "react-quill/dist/quill.snow.css";
import katex from 'katex';
import 'katex/dist/katex.min.css';

const AddQuestion = ({ isAdd, data, setSelectedData }) => {
  const baseUrl = "https://asquera.com/asquera";

  const dispatch = useDispatch();

  const [selected, setSelected] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [questionAnswerImg, setQuestionAnswerImg] = useState("");

  const [answers, setAnswers] = useState([]);
  const [rightAnswer, setRightAnwser] = useState();

  const [isTrueOrFalse, setIsTrueOrFalse] = useState(false);

  const openQuestions = useSelector((state) => state.model.isOpen16);
  const chapters = useSelector((state) => state.chapters.chapters);
  const tags = useSelector((state) => state.adminTags.tags);
  const isLoading = useSelector((state) => state.questionsBank.isLoading);
  useEffect(() => {
    if (openQuestions) {
      dispatch(getAllChaptersRequest());
      dispatch(getAllTagsRequest());
    }
  }, [openQuestions]);

  useEffect(() => {
    if (!isAdd) {
      setAnswers(data?.answers ?? []);
      const filter = data?.answers
        ?.map((data, index) => {
          if (data?.right_answer == 1) return index;
        })
        .filter((data) => data != undefined);
      if (filter?.length > 0) {
        setRightAnwser(filter[0]);
      }
    } else if (isAdd) {
      setAnswers([]);
      setRightAnwser(null);
      setSelectedTags([]);
    }
  }, [isAdd, data]);
  const chaptersOptions = chapters
    ?.filter((c) => Number(c?.active) === 0) // filter active == 0
    .map((c) => ({ value: c.id, label: c.name }));

  const tagsOptions = tags?.map((data) => {
    return { value: data.id, label: data.name };
  })

  const selectStyles = adminSelectStyles();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : { difficulty_level: "1", mark: 1 },
    shouldUnregister: true,
  });

  // Set tags when editing (must run after useForm so setValue is available)
  useEffect(() => {
    if (!isAdd && data?.tags) {
      const tagOptions = data.tags.map((t) => ({ value: t.id, label: t.name }));
      setSelectedTags(tagOptions);
      tagOptions.forEach((tag, idx) => setValue(`tags[${idx}]`, tag.value));
      const maxTags = 10;
      for (let i = tagOptions.length; i < maxTags; i++) {
        setValue(`tags[${i}]`, undefined);
      }
    }
  }, [isAdd, data, setValue]);

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color={brandPalette.primary}
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add Question" : "Edit Question"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(69, 11, 17, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Stem, answers, chapter, and tags
      </Text>
    </Box>
  );

  const onSubmit = async (val) => {
    const values = {
      ...val,
      difficulty_level: val?.difficulty_level ? val?.difficulty_level : "0",
    };
    const action = () => {
      dispatch(closeCreateQuestionModel());
      setSelectedData({});
      reset();
      setAnswers([]);
    };

    if (isAdd) {
      let formData = await new FormData();
      
      // Handle all form values except tags
      for (let key in values) {
        if (key !== 'tags') {
          if (key === 'url' && (values[key] == null || values[key] === '')) continue;
          formData.append(key, values[key]);
        }
      }
      
      // Handle tags: send only defined tag ids; when empty, omit tags so backend doesn't insert
      const tagIds = Object.values(values.tags || {}).filter(
        (v) => v !== undefined && v !== ''
      );
      if (tagIds.length > 0) {
        tagIds.forEach((id, idx) => formData.append(`tags[${idx}]`, id));
      }

      answers.map((data, idx) =>
        formData.append(`answers[${idx}][answer]`, data?.answer)
      );
      answers.map((data, idx) =>
        formData.append(
          `answers[${idx}][right_answer]`,
          data?.right_answer ? data?.right_answer : 0
        )
      );
      const filteredAnswers = answers?.filter(
        (data, idx) => data?.right_answer == 1
      );

      if (values.chapter_id && (answers?.length == 4 || answers?.length == 2)) {
        if (filteredAnswers?.length > 0)
          await dispatch(createQuestionBankRequest(formData, action));
        else toast.error("Select the correct answer.");
      } else {
        toast.error("Check answers and select a chapter.");
      }
    } else {
      let formData = await new FormData();
      const keys = [
        "select",
        "answers",
        "index",
        "delete",
        "edit",
        "chapter",
        "bookmark",
        "Actions",
        "deleted_at",

      ];
      formData.append("_method", "PUT");

      const totel = { ...data, ...values };
      answers.map((data, idx) =>
        formData.append(`answers[${idx}][id]`, data?.id)
      );



      answers.map((data, idx) =>
        formData.append(`answers[${idx}][answer]`, data?.answer)
      );
      answers.map((data, idx) =>
        formData.append(`answers[${idx}][right_answer]`, data?.right_answer)
      );

      for (let key in totel) {
        if (!keys.includes(key) && key !== 'tags') {
          if (key === 'url' && (totel[key] == null || totel[key] === '')) continue;
          formData.append(key, totel[key]);
        }
      }
      // Handle tags from form: send only defined tag ids; when empty, omit so backend can clear pivots
      const editTagIds = Object.values(values.tags || {}).filter(
        (v) => v !== undefined && v !== ''
      );
      if (editTagIds.length > 0) {
        editTagIds.forEach((id, idx) => formData.append(`tags[${idx}]`, id));
      }
      dispatch(
        editQuestionBankRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };
  const closeFunc = () => {
    dispatch(closeCreateQuestionModel());
    setSelectedData({});
    setAnswers([]);
    reset();
  };
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    ['formula'],
  
    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction
  
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
  
    ['clean']                                         // remove formatting button
  ];

  const quillRef = useRef(null);

useEffect(() => {
  if (quillRef.current) {
    // Initialize MathQuill after the component mounts
    const enableMathQuillFormulaAuthoring = MathQuill4Quill({ Quill: ReactQuill.Quill, katex: window.katex });
    enableMathQuillFormulaAuthoring(quillRef.current.getEditor(), {
      operators: [
        ["\\sqrt{x}", "\\sqrt"],
        ["\\sqrt[n]{x}", "\\nthroot"],
        ["x^2", "^"],
        ["x_n", "_"],
        ["\\frac{x}{y}", "\\frac"],
        ["\\int_a^b", "\\int"],
        ["\\sum_{i=0}^n", "\\sum"],
      ]
    });
  }
}, [quillRef]);

// Make katex available globally for Quill
window.katex = katex;

// Register formula module if needed
if (ReactQuill.Quill) {
const Quill = ReactQuill.Quill;

// Only register if not already registered
if (!Quill.imports['formats/formula']) {
const Formula = Quill.import('formats/formula');
Quill.register(Formula, true);
}
}
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openQuestions}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="5xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} w="100%" dir="ltr">
          <Box w="100%">
            <FormLabel
              m={0}
              mb={2}
              fontSize="14px"
              fontWeight="700"
              color={brandPalette.primary}
            >
              Passage (optional)
            </FormLabel>
            <Textarea
              name="comprehension"
              placeholder="Reading passage before the question"
              defaultValue={data?.comprehension}
              bg={brandPalette.cream}
              borderRadius="12px"
              border="1px solid"
              borderColor={brandPalette.stone}
              {...register("comprehension")}
            />
          </Box>
          <Box w="100%">
            <Text fontWeight="700" color={brandPalette.primary} mb={2}>
              Question body
            </Text>
            <ReactQuill
              theme="snow"
              register={register}
              name="question"
              defaultValue={data?.question}
              onChange={(val) => setValue("question", val)}
              modules={{ 
                toolbar: toolbarOptions,
                formula: true  // Enable formula module
              }}
            />
          </Box>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} w="100%">
            <MainInput
              label="Marks"
              defaultValues={data?.mark || 1}
              error={errors?.mark?.message}
              placeholder="Question marks"
              register={register}
              name="mark"
              type="number"
              required={false}
            />
            <MainInput
              label="URL (optional)"
              defaultValues={data?.url}
              error={errors?.url?.message}
              placeholder="https://..."
              register={register}
              name="url"
              type="url"
              required={false}
            />
          </SimpleGrid>
          <HStack w="100%" my="20px" justifyContent="space-between" flexWrap="wrap">
            <HStack w={{ base: "100%", md: "50%" }}>
              <FormLabel fontWeight="700" color={brandPalette.primary} whiteSpace="nowrap">
                Question image
              </FormLabel>
              <Button
                bg={brandPalette.primary}
                color="white"
                borderRadius="12px"
                textAlign="center"
                position="relative"
                _hover={{ bg: brandPalette.accentDark }}
              >
                <Text>
                  {selected
                    ? selected
                    : data?.image
                      ? `file_1`
                      : "Choose file"}
                </Text>
                <Input
                  onChange={(e) => {
                    setValue("image", e.target.files[0]);
                    setSelected((s) => e.target.files[0].name);
                  }}
                  type="file"
                  placeholder="اختر ملف ليتم رفعه"
                  opacity="0"
                  position="absolute"
                  w="100%"
                  h="100%"
                />
              </Button>
            </HStack>
            {data?.image && (
              <img src={`${baseUrl}/${data?.image}`} width="200px" />
            )}
          </HStack>

          <HStack w="100%" my="20px" justifyContent="space-between" flexWrap="wrap">
            <HStack w={{ base: "100%", md: "50%" }}>
              <FormLabel fontWeight="700" color={brandPalette.primary} whiteSpace="nowrap">
                Model answer image
              </FormLabel>
              <Button
                bg={brandPalette.primary}
                color="white"
                borderRadius="12px"
                textAlign="center"
                position="relative"
                _hover={{ bg: brandPalette.accentDark }}
              >
                <Text>
                  {questionAnswerImg
                    ? questionAnswerImg
                    : data?.model_answer_image
                      ? `file_1`
                      : "Choose file"}
                </Text>
                <Input
                  onChange={(e) => {
                    setValue("model_answer_image", e.target.files[0]);
                    setQuestionAnswerImg((s) => e.target.files[0].name);
                  }}
                  type="file"
                  placeholder="اختر ملف ليتم رفعه"
                  opacity="0"
                  position="absolute"
                  w="100%"
                  h="100%"
                />
              </Button>
            </HStack>
            {data?.image && (
              <img
                src={`${baseUrl}/${data?.model_answer_image}`}
                width="200px"
              />
            )}
          </HStack>

          <Box w="100%">
            <FormLabel fontWeight="700" color={brandPalette.primary} mb={2}>
              Difficulty / source
            </FormLabel>

            <Stack
              direction="row"
              role="group"
              aria-labelledby="my-radio-group"
              spacing="20px"
              flexWrap="wrap"
            >
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="1"
                  defaultChecked={data?.difficulty_level == 1 ? true : false}
                />
                notes
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="2"
                  defaultChecked={data?.difficulty_level == 2 ? true : false}
                />
                School book
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="3"
                  defaultChecked={data?.difficulty_level == 3 ? true : false}
                />
                hard questions
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="4"
                  defaultChecked={data?.difficulty_level == 4 ? true : false}
                />
                Past papers
              </label>
              <label>
                <input
                  {...register("difficulty_level")}
                  type="radio"
                  value="5"
                  defaultChecked={data?.difficulty_level == 5 ? true : false}
                />
                Revision
              </label>
            </Stack>
          </Box>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} w="100%">
            <FormControl>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                  textAlign="left"
                >
                  Chapter
                </FormLabel>
                <Select
                  options={chaptersOptions}
                  onChange={(d) => setValue("chapter_id", d.value)}
                  styles={selectStyles}
                  placeholder="Select chapter"
                  defaultValue={{
                    label: data?.chapter?.name,
                    value: data?.chapter?.id,
                  }}
                />
              </VStack>
            </FormControl>

            <FormControl>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                  textAlign="left"
                >
                  Tags
                </FormLabel>
                <Select
                  options={tagsOptions}
                  isMulti
                  value={selectedTags}
                  onChange={(d) => {
                    setSelectedTags(d || []);
                    const maxTags = 10;
                    for (let i = 0; i < maxTags; i++) {
                      setValue(`tags[${i}]`, undefined);
                    }
                    (d || []).forEach((tag, idx) => {
                      setValue(`tags[${idx}]`, tag.value);
                    });
                  }}
                  styles={selectStyles}
                  placeholder="Tags"
                />
              </VStack>
            </FormControl>
          </SimpleGrid>

          <Box w="100%">
            <FormLabel fontWeight="700" color={brandPalette.primary} mb={2}>
              Answers
            </FormLabel>
            <input
              type="checkbox"
              onChange={(e) => setIsTrueOrFalse(e.target.checked)}
              defaultChecked={isTrueOrFalse}
            />
            <label> True or False </label>

            {[...Array(isTrueOrFalse ? 2 : 4)].map((val, index) => {
              return (
                <HStack my="10px">
                  <Input
                    defaultValue={
                      data?.answers?.length > 0 && !isAdd
                        ? data?.answers[index]?.answer
                        : null
                    }
                    placeholder="Answer text"
                    size="md"
                    style={{ border: `1px solid ${brandPalette.stone}`, borderRadius: "12px" }}
                    onChange={(e) => {
                      const newAnswers = answers;
                      newAnswers[index] = {
                        ...newAnswers[index],
                        answer: e.target.value,
                      };
                      setAnswers(newAnswers);
                    }}
                  />

                  <Switch
                    size="lg"
                    // isChecked={defaultChecked(index)}
                    isChecked={rightAnswer == index ? true : false}
                    color={brandPalette.primary}
                    onChange={(e) => {
                      setRightAnwser(index);
                      let newAnswers = answers;
                      let mappedData = newAnswers?.map((val, idx) => {
                        return { ...val, right_answer: idx == index ? 1 : 0 };
                      });
                      setAnswers(mappedData);
                    }}
                  />

                  {/* {!isAdd && (
                    <Button
                      onClick={() =>
                        handelEditQuestion(data?.answers[index]?.id, index)
                      }
                    >
                      Edit
                    </Button>
                  )} */}
                </HStack>
              );
            })}
          </Box>

          <Flex justify="flex-end" gap={6} pt={4}>
            <Button
              variant="ghost"
              color={brandPalette.accentDark}
              fontWeight="800"
              _hover={{ textDecoration: "underline" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg={brandPalette.primary}
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: brandPalette.accentDark }}
              boxShadow="0 10px 24px rgba(91, 13, 22, 0.18)"
            >
              Save Changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddQuestion;


